import React, { Component } from "react";

import { createColorStyles } from "../common/utilities";
import PropTypes from "prop-types";

export class Modals extends Component {
    componentDidMount() {}

    render() {
        const { jobs, categories, isShowCollegeDegree, isShowSalary } = this.props;

        if (!jobs.length) {
            return null;
        }

        return jobs.map((job, jobIndex) => {
            const cat = categories.filter((cat) => cat.id === job.job_category.id)[0];

            const isShowSalaryInfo = isShowSalary && (job.compensation &&
                (job.compensation.salary && job.compensation.salary.low_end && job.compensation.salary.high_end) ||
                (job.compensation.hourly && job.compensation.hourly.low_end && job.compensation.hourly.high_end));

            return (
                <div
                    key={jobIndex}
                    className="modal-outer-wrapper"
                    id={`modal-${job.id}`}
                    style={createColorStyles(cat)}
                >
                    <div className="modal-inner-wrapper d-table">
                        <div className="d-table-cell">
                            <div className="modal">
                                <header className="modal-header">
                                    <div className="container">
                                        <button className="modal-close js-modal-close">
                                            <span className="show-for-sr">Close modal</span>
                                        </button>

                                        <div className="modal-category">{cat.name}</div>
                                        <h2 className="modal-job-name">{job.name}</h2>
                                    </div>
                                </header>

                                <div className="modal-body">
                                    <div className="modal-top">
                                        <div className="container">
                                            {job.job_description ? (
                                                <>
                                                    <div className="modal-description">
                                                        <div
                                                            dangerouslySetInnerHTML={{ __html: job.job_description }}
                                                        />

                                                        {job.image && job.image.url ? (
                                                            <img src={job.image.url} alt="job image" />
                                                        ) : null}

                                                        {job.indeed_url && (
                                                            <div className="modal-button-wrapper">
                                                                <a
                                                                    href={job.indeed_url}
                                                                    target="_blank"
                                                                    className="modal-button"
                                                                >
                                                                    Search Jobs
                                                                </a>
                                                            </div>
                                                        )}
                                                    </div>
                                                </>
                                            ) : null}

                                            <div className="modal-features">
                                                <div className="modal-feature">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-education" />
                                                        REQUIRED EDUCATION & TRAINING
                                                    </h3>
                                                    <div className="feature-description">
                                                        {isShowCollegeDegree && job.requires_college_degree ? (
                                                            <div className="college">
                                                                <span className="special diamond" /> College Degree
                                                            </div>
                                                        ) : (
                                                            "High School Diploma or Equivalent"
                                                        )}

                                                        {job.college_degree_description ? (
                                                            <div className="college-description">{job.college_degree_description}</div>
                                                        ) : null}
                                                        
                                                    </div>
                                                </div>

                                                {job.work_experience && (
                                                    <div className="modal-feature">
                                                        <h3 className="modal-feature-title">
                                                            <i className="icon-experience" />
                                                            WORK EXPERIENCE
                                                        </h3>
                                                        <div className="feature-description">{job.work_experience}</div>
                                                    </div>
                                                )}

                                                {isShowSalaryInfo && (
                                                    <div className="modal-feature">
                                                        <h3 className="modal-feature-title">
                                                            <i className="icon-pay" />
                                                            PAY
                                                        </h3>
                                                        <div className="feature-description">
                                                            {
                                                                job.compensation.salary && job.compensation.salary.low_end && job.compensation.salary.high_end ? (
                                                                    <div className="price annual">
                                                                        {job.compensation.salary.low_end} - {job.compensation.salary.high_end} / year
                                                                    </div>
                                                                ) : null
                                                            }

                                                            {
                                                                job.compensation.hourly && job.compensation.hourly.low_end && job.compensation.hourly.high_end  ? (
                                                                    <div className="price hour">
                                                                        {job.compensation.hourly.low_end} - {job.compensation.hourly.high_end} / hour
                                                                    </div>
                                                                ) : null
                                                            }
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-bottom">
                                        <div className="container">
                                            {job.skills_requirements && job.skills_requirements.length ? (
                                                <div className="modal-feature skills">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-skills" />
                                                        SKILLS & REQUIREMENTS
                                                    </h3>
                                                    <ul className="modal-list">
                                                        {typeof job.skills_requirements === "string"
                                                            ? job.skills_requirements
                                                                  .split("\n")
                                                                  .map((skill, skillIndex) =>
                                                                      skill.length ? (
                                                                          <li
                                                                              dangerouslySetInnerHTML={{
                                                                                  __html: skill
                                                                              }}
                                                                              key={skillIndex}
                                                                          />
                                                                      ) : null
                                                                  )
                                                            : job.skills_requirements.map((skill, skillIndex) => (
                                                                  <li key={skillIndex}>{skill}</li>
                                                              ))}
                                                    </ul>
                                                </div>
                                            ) : null}

                                            {job.job_suggested_content && job.job_suggested_content.length ? (
                                                <div className="modal-feature learning-material">
                                                    <h3 className="modal-feature-title">
                                                        <i className="icon-course" />
                                                        Training Programs & Resources
                                                    </h3>
                                                    <ul className="modal-list">
                                                        {job.job_suggested_content.map((content, contentIndex) => (
                                                            <li key={contentIndex}>
                                                                <a target={content.url ? '_blank' : '_self'} href={content.url || '#'}>
                                                                    {content.name}
                                                                </a>
                                                            </li>
                                                        ))}
                                                    </ul>
                                                </div>
                                            ) : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        });
    }
}

Modals.propTypes = {
    jobs: PropTypes.array.isRequired,
    categories: PropTypes.array.isRequired,
    isShowCollegeDegree: PropTypes.bool.isRequired
};
